import styled from 'styled-components';

export const SFullHeightDiv = styled.div`
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
`;
